
export {
  isDate,
  booleanConvertInt,
  convertDecimal
}

const isDate = (val) => {
  //如果是数字返回false
  if (!isNaN(val)) {
    return false
  }

  const date_timespan = new Date(val).getTime()
  //如果时间戳转换失败返回false
  if (isNaN(date_timespan)) {
    return false
  }

  return true
}

/**
 * Boolean值转换为Int
 * @param {Boolean} val bool值
 * @returns 
 */
const booleanConvertInt = (val) => {
  if (typeof (val) === "boolean") {
    return val ? 1 : 0
  }
}
/**
 * 转换小数点
 * @param {*} val 
 * @returns 
 */
const convertDecimal = (val) => {
  var result = val
  if (typeof (val) === "string") {
    result = parseFloat(result)

  }

  result = result || 0

  return parseFloat(result.toFixed(2))
}
